import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { List, TextField, EditButton, ShowButton, Datagrid, SimpleList, TopToolbar, CreateButton } from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { ExamsExporter } from "./XlsxExporter";
import { MobileListRow } from "features/MobileListRow";

const ListExams = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();
  
  const ListActions = (hasCreate) => {
    return (
      <TopToolbar>
        { hasCreate && <CreateButton/> } 
        <ExportXlsButton exporter={ExamsExporter}/>
      </TopToolbar>
    )
  }

  return (
    <List
      title="Изпити"
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateExams)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow fields={[{ label: "Описание", value: record.description }]} />
            </div>
          )}
          tertiaryText={() => (
            <>
              {checkPermission(getPermissions(), permissions.canUpdateExams) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <TextField
            source="description"
            label="Описание"
            sortable={false}
          />
          <SecuredComponent permission={permissions.canUpdateExams}>
            <EditButton />
          </SecuredComponent>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListExams;
